import React from "react";
import {
  Funnel,
  FunnelChart as BaseChart,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function FunnelChart(props) {
  const { def } = props?.data?.valor || {};

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BaseChart>
        <Tooltip />
        <Funnel dataKey="val" data={def} isAnimationActive />
      </BaseChart>
    </ResponsiveContainer>
  );
}
